import {firstPage, setupTables, TableDataRequest} from '@fl/cmsch-fe-library';
import {opt, Opt} from 'ts-opt';

import {TableFilter} from 'api/gen/TableFilter';
import {AppAction} from 'app/setup/app-action';
import {State} from 'app/setup/state';
import {TableRowMap} from 'types/table-row-map';

const {
    ConnectedTable: appConnectedTable,
    getRequestedTableColumnSettings: appGetRequestedTableColumnSettings,
    getRequestedTablePageParams: appGetRequestedTablePageParams,
    initialTablesState: appInitialTablesState,
    tablesAction: appTablesAction,
    tablesReducer: appTablesReducer,
    tablesSagas: appTablesSagas,
    simpleTableSelector: appSimpleTableSelector,
    convertTableDataParamsToDto: appConvertTableDataParamsToDto,
    getRequestedTableCsvExportParams: appGetRequestedTableCsvExportParams,
    getTableFiltersAndParams: appGetTableFiltersAndParams,
    createTableUserSettings: appCreateTableUserSettings,
} = setupTables<TableRowMap, State, AppAction, TableFilter>();

/** Connected table component configured for the Eskot store and row map. */
export const ConnectedTable = appConnectedTable;

/** Extracts requested column settings from the current table state. */
export const getRequestedTableColumnSettings = appGetRequestedTableColumnSettings;

/** Extracts requested pagination and sorting parameters from the current table state. */
export const getRequestedTablePageParams = appGetRequestedTablePageParams;

/** Default table state snapshot for the Eskot application. */
export const initialTablesState = appInitialTablesState;

/** Redux action creators for shared table pagination, filters, and user settings. */
export const tablesAction = appTablesAction;

/** Reducer that stores shared table state for the Eskot application. */
export const tablesReducer = appTablesReducer;

/** Root saga registrations for shared table side effects. */
export const tablesSagas = appTablesSagas;

/** Selectors for reading shared table state from the Eskot store. */
export const simpleTableSelector = appSimpleTableSelector;

/** Converts table data parameters into DTO payloads expected by backend APIs. */
export const convertTableDataParamsToDto = appConvertTableDataParamsToDto;

/** Extracts CSV export parameters from the current table state. */
export const getRequestedTableCsvExportParams = appGetRequestedTableCsvExportParams;

/** Combines table filters and page params into a single request payload. */
export const getTableFiltersAndParams = appGetTableFiltersAndParams;

/** Creates persisted table user settings objects for Eskot tables. */
export const createTableUserSettings = appCreateTableUserSettings;

/** Creates a table request that preserves its current state and loads the first page. */
export const firstPageTableDataRequest = <Row>(): Opt<TableDataRequest<Row>> =>
    opt({action: 'changePageNumber', page: firstPage});
